import { getApi } from "@beeldit/core/helpers/api";

function confirmAccount(confirmData: any, onSuccess: any, onError: any) {
  const run = async (data: any) => {
    try {
      const response = await getApi().post("/confirm-account", data);
      onSuccess(response.data);
    } catch (error) {
      console.error("Error confirming account:", error);
      onError(error);
    }
  };

  run(confirmData);
}

export default confirmAccount;
